import { IMapFilter } from "@/interfaces"
import { Coordinates } from "@/types"
import moment from "moment"
import { defineStore } from "pinia"
import { ref } from "vue"

const STORE_KEY = 'MAP_FILTER_STORE'
export const useMapFilterStore = defineStore(STORE_KEY, () => {
    const mapfilters = ref<IMapFilter>({
        all: true,
        fast: false,
        twenty_four_hours: false
    })
    const currentMapCenter = ref<Coordinates>()

    const getLastLocationFromLocalStorage = (): { coords: Coordinates, timestamp: number } | null => {
        const item = localStorage.getItem('LAST_LOCATION_STORAGE')
        if (!item) return null
        return JSON.parse(item)
    }

    const lastUserLocation = ref<{ coords: Coordinates, timestamp: number } | null>(getLastLocationFromLocalStorage())

    const updateMapFilters = (f: IMapFilter) => {
        mapfilters.value = f
    }
    const updateCurrentCenter = (c: Coordinates) => {
        currentMapCenter.value = c
    }
    const saveUserLastLocation = (c: Coordinates) => {
        const obj = {
            coords: c,
            timestamp: moment().valueOf()
        }
        localStorage.setItem('LAST_LOCATION_STORAGE', JSON.stringify(obj))
        lastUserLocation.value = obj
    }



    return { mapfilters, currentMapCenter, updateMapFilters, updateCurrentCenter, lastUserLocation, saveUserLastLocation }
})